import { useDecision } from '@optimizely/react-sdk'
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { checkAndRequestPermission, onMessageListener } from '../../lib/firebase';
import { firebaseAlertState } from '../../common/AlertDisplay/AlertDisplay.state';
import { FirebaseNotificationBody } from './FirebaseNotification.style';

const FirebaseNotification = () => {
    const [decisionPushNotifications] = useDecision('push-notifications');
    const setAlert = useSetRecoilState(firebaseAlertState)

    // Listen for incoming messages and handle them
    const handleMessage = async (payload) => {
        try {
            if (decisionPushNotifications?.enabled) {
                setAlert({
                    type: "info", message: (
                        <FirebaseNotificationBody>
                            {payload.notification.title ? <p><strong>{`${payload.notification.title} Push Notification`}</strong></p> : null}
                            {payload.notification.body ? <p>{payload.notification.body}</p> : null}
                        </FirebaseNotificationBody>
                    ), 
                    closable: true, 
                    autoClose: true,
                });
            }
        } catch (err) {
            console.error('Failed handling message: ', err);
        }
    };

    // Pass the message handler to the listener
    onMessageListener(handleMessage);

    useEffect(() => {
        let hasNotificationPermissionChecked = false;

        const requestPermission = async () => {
            if (decisionPushNotifications?.enabled && !hasNotificationPermissionChecked) {
                await checkAndRequestPermission();
                hasNotificationPermissionChecked = true;
            }
        };

        requestPermission();

        // Cleanup function to cancel the request if the component unmounts
        return () => {
            hasNotificationPermissionChecked = true;
        };
    }, [decisionPushNotifications]);

    return null
}

export default FirebaseNotification